import { Component, OnInit, Inject } from '@angular/core';

import { BaseComponent } from '~Interfaces/basecomponent';
import { UtilisateurService } from '../../services/utilisateur.service';

/**
 * Composant pour lister les fournisseurs
 */
@Component({
  selector: 'app-lister-fournisseurs',
  templateUrl: './lister-fournisseurs.component.html',
  styleUrls: ['./lister-fournisseurs.component.scss']
})
export class ListerFournisseursComponent extends BaseComponent implements OnInit {
    public codeFournisseur: string = null;
    public listeFournisseurs: any[] = [];

    constructor(@Inject(UtilisateurService) private utilisateurService: UtilisateurService) { super(); }

    /**
     * Initialisation du composant
     */
    ngOnInit() {
        this.utilisateurService.obtenirUtilisateurCourant().subscribe((retour: any) => {
            if (retour && retour.Result) {
                this.listeFournisseurs = retour.Result.ListeFournisseurs;
            }
        });
    }

    /**
     * S�lectionner le fournisseur
     * @param codeFournisseur
     */
    selectionnerFournisseur(codeFournisseur: string) {
        this.codeFournisseur = codeFournisseur;
    }
}
